import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import { Home } from "./components/Home";
import AdministratorIndex from "./pages/Administrator/AdministratorIndex";
import MenuAccess from "./pages/Administrator/MenuAccess/MenuAccess";
import UserManagement from "./pages/Administrator/UserManagement/UserManagement";
import ListViewV2 from "./pages/App/DataListV2";
import Process from "./pages/App/Process";
import Uploader from "./pages/App/Uploader";
import UploaderIndex from "./pages/App/Uploader/UploaderIndex";
import { Welcome } from "./pages/App/Welcome";
import MainLogin from "./pages/Authentication/Login";
import Logout from "./pages/Authentication/Logout";
import MainLayout from "./pages/Layouts/MainLayout";
import ListHistory from "./pages/HistoryNew/ListHistory";
import CustomerList from "./pages/Static/Customers";
import AddCustomer from "./pages/Administrator/AddCustomer/AddCustomer";

import "./assets/css/nucleo-svg.css";
import "./assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-design-system.scss?v1.0.0";
import "./pages/styles/general.css";

import UploadedCommentIndex from "pages/App/Custom/CustomUploadComments";
import UpdatePesanan from "pages/Static/UpdatePesanan";
import { UpdateAddress } from "pages/Sites/UpdateAddress";
import BalanceMutation from "pages/Administrator/BalanceMutation/BalanceMutation";
import Coupon from "pages/App/Coupon/Coupon";
import UploadReportShopee from "pages/App/Custom/CustomUploadReportShopee";
import WarehouseInventory from "pages/App/Shopee/WarehouseInventory";
import ProsesResi from "pages/App/Shopee/ProsesResi";
import ProsesBarang from "pages/App/Shopee/ProsesBarang";
import ProsesPacking from "pages/App/Shopee/ProsesPacking";
import ProsesRetur from "pages/App/Shopee/ProsesRetur";
import ProsesKirimDepok from "pages/App/Shopee/ProsesKirimDepok";
import ProcessShopee from "pages/App/ProcessShopee";
import DashboardPesanan from "pages/Static/DashboardPesanan";
import ListKeepan from "pages/Static/ListKeepan";
import ListOngkirManual from "pages/Static/ListOngkirManual";
import ListBayarManual from "pages/Static/ListBayarManual";
import PesananSiapKirim from "pages/Static/PesananSiapKirim";
import PengirimanPesanan from "pages/Static/PengirimanPesanan";
import Manualan from "pages/Static/Manualan/Manualan";
import Customer360Dashboard from "pages/Customers360/Customer360";
import ReportBC from "pages/Static/ReportBC";
import PrintResiBC from "pages/Static/PrinterResi/PrintResiBC";
import WatchListTiktok from "pages/App/Tiktok/WatchList";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Routes>
        <Route index element={<Home />} />
        <Route path="customers/360" element={<Customer360Dashboard />} />

        <Route path="authentication/login" element={<MainLogin />} />
        <Route path="authentication/logout" element={<Logout />} />
        <Route path="users/address/:nowa" element={<UpdateAddress />} />
        <Route path="app" element={<MainLayout />}>
          <Route index element={<Welcome />} />
          {/** Custom list Route*/}
          <Route
            path="list/uploadcomments"
            element={<UploadedCommentIndex />}
          />
          {/** Custom list Shopee Route*/}
          <Route path="shopee/inventory" element={<WarehouseInventory />} />
          <Route path="shopee/kirimdepok" element={<ProsesKirimDepok />} />
          <Route path="shopee/proses/resi" element={<ProsesResi />} />
          <Route path="shopee/proses/barang" element={<ProsesBarang />} />
          <Route path="shopee/proses/packing" element={<ProsesPacking />} />
          <Route path="shopee/proses/retur" element={<ProsesRetur />} />

          {/** Custom list Tiktok Route */}
          <Route path="tiktok/watchlist" element={<WatchListTiktok />} />

          <Route path="process/shopee" element={<ProcessShopee />} />
          {/** Custom list Route*/}
          <Route path="static/customers" element={<CustomerList />} />
          <Route path="print/resibc" element={<PrintResiBC />} />
          <Route path="list/dashboardpesanan" element={<DashboardPesanan />} />
          <Route path="list/updatepesanan" element={<UpdatePesanan />} />
          <Route path="list/bcpacking" element={<PengirimanPesanan />} />
          <Route path="list/reportbc" element={<ReportBC />} />
          <Route path="list/bcsiapkirim" element={<PesananSiapKirim />} />
          <Route path="list/listkeepan" element={<ListKeepan />} />
          <Route path="list/ongkirmanual" element={<ListOngkirManual />} />
          <Route path="list/bayarmanual" element={<ListBayarManual />} />
          <Route path="list/bcmanualan" element={<Manualan />} />
          <Route path="list/coupons" element={<Coupon />} />
          <Route path="upload" element={<UploaderIndex />} />
          <Route path="addcustomer" element={<AddCustomer />} />
          <Route path="upload/reportshopee" element={<UploadReportShopee />} />
          <Route path="upload/:type" element={<Uploader />} />
          <Route path="list/:viewId" element={<ListViewV2 />} />
          <Route path="hist/:viewId" element={<ListHistory />} />
          <Route path="process/:mode" element={<Process />} />
          <Route path="administrator" element={<AdministratorIndex />} />
          <Route path="administrator/access" element={<MenuAccess />} />
          <Route path="administrator/mutation" element={<BalanceMutation />} />
          <Route path="administrator/users" element={<UserManagement />} />
          <Route path="administrator/addcustomer" element={<AddCustomer />} />
        </Route>
      </Routes>
    );
  }
}
